import type {
  ProductCollectionPageQuery,
  ProductCollectionPageQueryVariables,
} from 'src/types';
import productCollectionPageQuery from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useProductCollectionPageQuery(
  variables: ProductCollectionPageQueryVariables
) {
  return usePageQuery<ProductCollectionPageQuery>({
    query: productCollectionPageQuery,
    routeName: 'productCollection',
    variables,
  });
}
